// extracted by mini-css-extract-plugin
export default {"container":"LandingLayout_container__XOJVI","content":"LandingLayout_content__yO08x","scroll_is_disabled":"LandingLayout_scroll_is_disabled__+YpzO"};